export default "__VITE_ASSET__CYsed2AB__"